import React, { useState, useCallback, useEffect } from "react";
import "./Activity.css";
import "../Gallery/Gallery.css";
import { Link } from "react-router-dom";
import taxi from "../../../images/taxi.jpeg";
import taxi1 from "../../../images/taxi2.jpg";
import taxi2 from "../../../images/taxi3.jpg";
import taxi3 from "../../../images/taxi4.jpg";
import k1 from "../../../images/photo_5976566633449243966_y.jpg";
import k2 from "../../../images/photo_5976566633449243972_y.jpg";
import k3 from "../../../images/photo_5976566633449243973_y.jpg";
import k4 from "../../../images/photo_5976566633449243974_y.jpg";
import k5 from "../../../images/photo_5976566633449243979_y.jpg";
import k6 from "../../../images/photo_5976566633449243977_y.jpg";
import n1 from "../../../images/7294348d-f284-40bf-8e62-295d3c85d0de.jpeg";
import n2 from "../../../images/c86382ee-095c-4459-a64b-c5d2c4d640b1.jpeg";
import n3 from "../../../images/d7b94117-07ca-4993-a02d-8d84322a3876.jpeg";
import n4 from "../../../images/46fe90c6-10d6-4671-aa9a-677da281d534.jpeg";
import n5 from "../../../images/telemedicine-consultation-uganda.jpeg";
import ts1 from "../../../images/WhatsApp Image 2024-07-02 at 11.02.47 PM.jpeg";
import ts2 from "../../../images/photo_5976566633449244005_y.jpg";
import ts3 from "../../../images/WhatsApp Image 2024-07-02 at 11.06.17 PM (2).jpeg";
import ts4 from "../../../images/WhatsApp Image 2024-07-02 at 11.02.46 PM (2).jpeg";
import upcoming from "../../../images/upc.jpeg";
import m2 from "../../../images/m2.jpeg";
import m3 from "../../../images/m3.jpeg";
import m1 from "../../../images/m1.jpeg";
import m5 from "../../../images/m5.jpeg";
import m4 from "../../../images/m4.jpeg";
import m6 from "../../../images/m6.jpeg";
import m7 from "../../../images/m7.jpeg";
import m8 from "../../../images/m8.jpeg";
import m9 from "../../../images/m9.jpeg";
import D1 from "../../../images/photo_5976566633449243967_y.jpg";
import D2 from "../../../images/photo_5976566633449243970_y.jpg";
import D3 from "../../../images/photo_5976566633449243973_y.jpg";
import D4 from "../../../images/photo_5976566633449243968_y.jpg";

const ongoingActivities = [
  {
    title:
      "Federation of Uganda Taxi Operators (UTOF) Partnership - Healthcare for Taxi Drivers",
    description:
      "The MoU and working relationship with taxi drivers (UTOF) is taking shape. Our doctors, nurses, and lab team conducted a launch with partners including Kommute and Harvey Institute of Health Nkozi, where over 150 taxi drivers received free healthcare screening, consultation, health education, and treatment. We are dedicated to revolutionising doctor-led healthcare services to individuals, remote areas, and mass communities across Uganda.",
    images: [taxi, taxi1, taxi2, taxi3],
    partners: ["Kommute", "Harvey Institute of Health Nkozi", "UTOF"],
    highlight: "150+ taxi drivers reached",
  },
];

const activities = [
  {
    title:
      "Mawokota-Mpigi NCD, Sickle Cell, prostate cancer, diabetes, hypertension and other disease screening and treatment.",
    description:
      "we organised free medical camp in partnership with Mulago NRH , Uganda Medical Association ,Ernest Cook University, Abacus pharma, ASG Eye Hospital,The Empowered Community and other key partners ",

    images: [m5, m2, m3, m4, m6, m7, m8, m9],
  },
  {
    title: "Free Medical Camp - Kawempe, Uganda Medical Association",
    description:
      "We joined a team mobilised by the Uganda Medical Association and Radio Maria to provide free outdoor healthcare services to people of Kawempe, Jinja Karoli, and surrounding Kampala areas. Specialist physicians, general practitioners, and ENT surgeons participated. Yita Life bridges the gap between patients and doctors through cost-effective health promotion and outdoor healthcare access.",
    images: [k1, k2, k3, k4, k5, k6],
  },
  {
    title:
      "Non-communicable disease screening and treatment activity in Mpererwe-wakiso",
    description:
      "We partnered with Daughters of Hope to provide health Education and screen for Hypertension, Sickle cell,prostrate cancer,kidney disease, Diabetes and other NCDs .",
    images: [D1, D2, D3, D4],
  },
  {
    title:
      "Health Awareness, Medical screening, and Treatment - Naguru Go Down",
    description:
      "Our team organised a successful health awareness event at Naguru Go Down, a vibrant community hub in the heart of the city. The event focused on educating and sensitising the public on the importance of prioritising health and wellness in daily life - covering screening, nutrition, and preventive care.",
    images: [n1, n2, n3, n4, n5],
  },
  {
    title: "Health Talk Shows - Radio, TV & Digital Platforms",
    description:
      "Our medical team actively engages in health talk shows across radio stations, television channels, online platforms, and community events - sharing expert insights, addressing health concerns, and providing personalised guidance. We use social media, podcasts, and webinars to reach a wider audience and inspire healthy lifestyle choices across Uganda and beyond.",
    images: [ts1, ts2, ts3, ts4],
  },
];

const upcomingServices = [
  "Blood sugar & diabetes screening",
  "Kidney & eye health",
  "Dental check-ups",
  "Prostate screening",
  "Nutritional counselling",
  "Elder care (17–65+)",
];

function Activity() {
  const [lightbox, setLightbox] = useState({ images: [], index: null });

  const openLightbox = (images, index) => setLightbox({ images, index });
  const closeLightbox = () => setLightbox({ images: [], index: null });

  const next = useCallback(
    () =>
      setLightbox((prev) => ({
        ...prev,
        index: prev.index === prev.images.length - 1 ? 0 : prev.index + 1,
      })),
    [],
  );

  const prev = useCallback(
    () =>
      setLightbox((prev) => ({
        ...prev,
        index: prev.index === 0 ? prev.images.length - 1 : prev.index - 1,
      })),
    [],
  );

  useEffect(() => {
    const onKey = (e) => {
      if (lightbox.index === null) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightbox.index, next, prev]);

  return (
    <div>
      {/* ── HERO ── */}
      <div className="page-hero">
        <div className="container page-hero-content">
          <h1 data-aos="fade-down">Our Activities</h1>
          <p data-aos="fade-up" data-aos-delay="80">
            Community outreach, medical camps &amp; social responsibility
          </p>
          <div className="page-breadcrumb">
            <Link to="/">Home</Link>
            <ion-icon
              name="chevron-forward-outline"
              style={{ fontSize: "13px" }}
            ></ion-icon>
            <span>Activities</span>
          </div>
        </div>
      </div>

      <div className="activity-page-wrapper">
        <div className="container">
          {/* ── UPCOMING EVENT ── */}
          <div data-aos="fade-up">
            <div className="upcoming-banner">
              <div className="upcoming-banner-img">
                <img src={upcoming} alt="Upcoming Health Camp in Buganda" />
              </div>
              <div className="upcoming-content">
                <div className="upcoming-badge">
                  <ion-icon name="calendar-outline"></ion-icon>
                  Recent Events
                </div>
                <h2>Free Health Camp - Buganda Kingdom</h2>
                <p>
                  Join us for a FREE Health Camp themed:{" "}
                  <em>"Health is the Foundation of Prosperity."</em> Open to all
                  - no registration fee required.
                </p>
                <div className="upcoming-meta">
                  <div className="upcoming-meta-item">
                    <ion-icon name="calendar-outline"></ion-icon>
                    November 13, 2024
                  </div>
                  <div className="upcoming-meta-item">
                    <ion-icon name="location-outline"></ion-icon>
                    Bulange, Mengo
                  </div>
                  <div className="upcoming-meta-item">
                    <ion-icon name="time-outline"></ion-icon>
                    From 8:00 AM
                  </div>
                  <div className="upcoming-meta-item">
                    <ion-icon name="call-outline"></ion-icon>
                    0704924200
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "13px",
                    color: "rgba(255,255,255,0.55)",
                    marginBottom: "10px",
                  }}
                >
                  SERVICES OFFERED:
                </p>
                <div className="upcoming-services-list">
                  {upcomingServices.map((s, i) => (
                    <span className="upcoming-service-tag" key={i}>
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="upcoming-banner-img">
              <img src={m1} alt="Upcoming Health Camp in Buganda" />
            </div>
          </div>

          {/* ── ONGOING ACTIVITIES ── */}
          <h2 className="activities-section-heading" data-aos="fade-up">
            Ongoing Activities
          </h2>

          {ongoingActivities.map((act, i) => (
            <div
              className="ongoing-activity-card"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 60}
            >
              <div className="ongoing-card-header">
                <div className="ongoing-status-badge">
                  <span className="ongoing-pulse"></span>
                  Ongoing
                </div>
                <h2>{act.title}</h2>
                {act.highlight && (
                  <div className="ongoing-highlight">
                    <ion-icon name="people-outline"></ion-icon>
                    {act.highlight}
                  </div>
                )}
              </div>
              <div className="ongoing-card-body">
                <p>{act.description}</p>
                {act.partners && (
                  <div className="ongoing-partners">
                    <span className="ongoing-partners-label">
                      <ion-icon name="handshake-outline"></ion-icon>
                      Partners:
                    </span>
                    {act.partners.map((p, pi) => (
                      <span className="ongoing-partner-tag" key={pi}>
                        {p}
                      </span>
                    ))}
                  </div>
                )}
                <div className="activity-image-grid">
                  {act.images.map((img, ii) => (
                    <div
                      className="activity-img-item"
                      key={ii}
                      role="button"
                      tabIndex={0}
                      style={{ cursor: "pointer" }}
                      onClick={() => openLightbox(act.images, ii)}
                      onKeyDown={(e) =>
                        e.key === "Enter" && openLightbox(act.images, ii)
                      }
                    >
                      <img
                        src={img}
                        alt={`${act.title} - photo ${ii + 1}`}
                        loading="lazy"
                      />
                      <div className="gallery-item-overlay">
                        <ion-icon
                          name="expand-outline"
                          className="gallery-zoom-icon"
                        ></ion-icon>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}

          {/* ── RECENT ACTIVITIES ── */}
          <h2 className="activities-section-heading" data-aos="fade-up">
            Recent Activities
          </h2>

          {activities.map((act, i) => (
            <div
              className="activity-card-new"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 60}
            >
              <div className="activity-card-header">
                <div className="activity-card-number">{i + 1}</div>
                <h2>{act.title}</h2>
              </div>
              <div className="activity-card-body">
                <p>{act.description}</p>
                <div className="activity-image-grid">
                  {act.images.map((img, ii) => {
                    const isM5 = act.images[0] === m5 && ii === 0;
                    return (
                      <div
                        className="activity-img-item"
                        key={ii}
                        role="button"
                        tabIndex={0}
                        style={{
                          cursor: "pointer",
                          ...(isM5
                            ? { gridColumn: "span 2", aspectRatio: "16/9" }
                            : {}),
                        }}
                        onClick={() => openLightbox(act.images, ii)}
                        onKeyDown={(e) =>
                          e.key === "Enter" && openLightbox(act.images, ii)
                        }
                      >
                        <img
                          src={img}
                          alt={`${act.title} - photo ${ii + 1}`}
                          loading="lazy"
                        />
                        <div className="gallery-item-overlay">
                          <ion-icon
                            name="expand-outline"
                            className="gallery-zoom-icon"
                          ></ion-icon>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}

          {/* ── OUTREACH CTA ── */}
          <div className="outreach-cta" data-aos="fade-up">
            <h3>Want to Participate or Partner with Us?</h3>
            <p>
              We welcome community partnerships, corporate CSR collaborations,
              and individual volunteers who share our vision.
            </p>
            <div className="outreach-cta-btns">
              <Link to="/Contact">
                <button
                  style={{
                    background: "var(--accent)",
                    color: "white",
                    border: "none",
                    padding: "14px 30px",
                    borderRadius: "8px",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 700,
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                >
                  Get Involved
                </button>
              </Link>
              <Link to="/Gallery">
                <button
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    color: "white",
                    border: "2px solid rgba(255,255,255,0.3)",
                    padding: "13px 30px",
                    borderRadius: "8px",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 700,
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                >
                  View Our Gallery
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* ── LIGHTBOX ── */}
      {lightbox.index !== null && (
        <div
          className="gallery-modal"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label="Photo lightbox"
        >
          <div
            className="gallery-modal-inner"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="gallery-modal-close"
              onClick={closeLightbox}
              aria-label="Close"
            >
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <img
              src={lightbox.images[lightbox.index]}
              alt={`Photo ${lightbox.index + 1}`}
            />
            <div className="gallery-modal-nav">
              <button
                className="gallery-nav-btn"
                onClick={prev}
                aria-label="Previous"
              >
                <ion-icon name="chevron-back-outline"></ion-icon> Previous
              </button>
              <button
                className="gallery-nav-btn"
                onClick={next}
                aria-label="Next"
              >
                Next <ion-icon name="chevron-forward-outline"></ion-icon>
              </button>
            </div>
            <div className="gallery-counter">
              {lightbox.index + 1} / {lightbox.images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Activity;
